export function getSeasons() {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  const startYear = currentMonth >= 9 ? currentYear : currentYear - 1;
  const seasons = [];
  for (let year = startYear; year >= 2013; year--) {
    seasons.push(year);
  }
  return seasons;
}

export function getNextOpponent(teams) {
  const teamWithNextOpponent = teams.find((team) => team.next_opponent);
  return teamWithNextOpponent
    ? teamWithNextOpponent.team_id
    : teams[0]?.team_id;
}

export function safeNextPath(next) {
  return typeof next === "string" &&
    next.startsWith("/") &&
    !next.startsWith("//") &&
    !next.includes("\\")
    ? next
    : null;
}

export function formatGameLabel(key) {
  const m = key.match(/^(\d{4})(\d{2})(\d{2})_(vs|at)_(.+)$/);
  if (!m) return key;
  return `${m[1]}-${m[2]}-${m[3]} ${m[4]} ${m[5]}`;
}
